import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import { getDecision, saveDecision } from "../services/api";

export function EditDecision() {
    const { decisionId } = useParams()
    const [decision, setDecision] = useState({schedule: "Daily"})
    const navigate = useNavigate()
    
    const options = [
        {
            name: "Standard",
            value: "Standard"
        },
        {
            name: "Sliding",
            value: "Sliding"
        },
        {
            name: "Weekday Only",
            value: "WeekdayOnly"
        },
        {
            name: "Work Location",
            value: "WorkLocation"
        },
        {
            name: "Workout",
            value: "Workout"
        },
        {
            name: "Casino",
            value: "Casino"
        },
        {
            name: "Buy Car",
            value: "BuyCar"
        },
        {
            name: "Daily Chore",
            value: "DailyChore"
        },
        {
            name: "Eat Out",
            value: "EatOut"
        }
    ]
    
    const scheduleOptions = [
        {
            name: "Daily",
            value: "Daily"
        },
        {
            name: "Meals",
            value: "Meals"
        }
    ]

    useEffect(() => {
        if (decisionId !== "new") {
            getDecision(decisionId)
                .then(apiDecision => {
                    setDecision(apiDecision)
                })
                .catch(ex => {
                    console.log("Error getting decision: ", ex)
                }, [])
        } else {
            setDecision({
                ...decision,
                activeFlag: true
            })
        }
    }, []);
    
    const updateName = (event) => {
        setDecision({
            ...decision,
            name: event.target.value
        })
    }
    
    const updateMessageText = (event) => {
        setDecision({
            ...decision,
            messageText: event.target.value
        })
    }
    
    const updateRejectionMessage = (event) => {
        setDecision({
            ...decision,
            rejectionMessage: event.target.value
        })
    }
    
    const updateInt = (event, key) => {
        const newValue = event.target.value
        if (newValue === '') {
            setDecision({
                ...decision,
                [key]: null
            })
        }
        
        if (!isNaN(+newValue)) {
            setDecision({
                ...decision,
                [key]: newValue
            })
        }
    }
    
    
    const updateProbability = (event) => {
        /*const newValue = event.target.value
        if (newValue === '') {
            setDecision({
                ...decision,
                probability: null
            })
        }
        
        if (!isNaN(+newValue)) {
            setDecision({
                ...decision,
                probability: newValue
            })
        }*/
        updateInt(event, "probability")
    }
    
    const updatePity = (event) => {
       updateInt(event, "pity")
    }
    
    const updateCooldown = (event) => {
        updateInt(event, "coolDown")
    }

    const updateCreated = (event) => {
        setDecision({
            ...decision,
            created: event.target.value
        })
    }
    
    const updateAlgorithm = (event) => {
        setDecision({
            ...decision,
            algorithm: event.target.value
        })
    }

    const updateSchedule = (event) => {
        setDecision({
            ...decision,
            schedule: event.target.value
        })
    }


    const updateNote = (event) => {
        setDecision({
            ...decision,
            notes: event.target.value
        })
    }
    
    const toggleActive = (event) => {
        setDecision({
            ...decision,
            activeFlag: !decision.activeFlag
        })
    }
    
    const submit = async (event) => {
        event.preventDefault()
        
        try {
            await saveDecision(decision)
            navigate("/decisions")
            
        } catch (ex) {
            console.log("Error saving decision: ", ex)
        }
    }
    
    return (
        <form onSubmit={submit}>
            <div className="form-group mb-3">
                <label>Name</label>
                <input
                    type="text"
                    className="form-control"
                    value={decision.name}
                    onChange={updateName}/>
            </div>
            <div className="form-group mb-3">
                <label>Message Text</label>
                <input
                    type="text"
                    className="form-control"
                    value={decision.messageText}
                    onChange={updateMessageText}/>
            </div>
            <div className="form-group mb-3">
                <label>Rejection Text</label>
                <input
                    type="text"
                    className="form-control"
                    value={decision.rejectionMessage}
                    onChange={updateRejectionMessage} />
            </div>
            <div className="form-group mb-3">
                <label>Notes</label>
                <textarea value={decision.notes}
                          className="form-control"
                          onChange={updateNote}
                ></textarea>
            </div>
            <div className="form-group mb-3">
                <label>Probability</label>
                <input
                    type="number"
                    className="form-control"
                    value={decision.probability}
                    onChange={updateProbability}/>
            </div>
            <div className="form-group mb-3">
                <label>Pity</label>
                <input
                    type="number"
                    className="form-control"
                    value={decision.pity}
                    onChange={updatePity}/>
            </div>
            <div className="form-group mb-3">
                <label>Cooldown</label>
                <input
                    type="number"
                    className="form-control"
                    value={decision.coolDown}
                    onChange={updateCooldown}/>
            </div>
            <div className="form-group mb-3">
                <label>Created</label>
                <input
                    type="text"
                    className="form-control"
                    value={decision.created}
                    onChange={updateCreated}/>
            </div>
            <div className="form-group mb-3">
                <label>Algorithm</label>
                <select className="form-control"
                        onChange={updateAlgorithm}
                        value={decision.algorithm}
                >
                    {options.map(o => {
                        console.log(o);
                        return (
                            <option value={o.value}>{o.name}</option>
                        )
                    })}
                </select>
            </div>
            <div className="form-group mb-3">
                <label>Schedule</label>
                <select
                    className="form-control"
                    onChange={updateSchedule}
                    value={decision.schedule}
                >
                    {scheduleOptions.map(o => {
                        return (
                            <option value={o.value} key={o.value}>{o.name}</option>
                        )
                    })}
                </select>
            </div>
            <div className="form-group mb-3">
                <label>Active</label>
                <input
                    type="checkbox"
                    className="form-check"
                    checked={decision.activeFlag}
                    onChange={toggleActive}/>
            </div>
            <div className="form-group">
                <button className="btn btn-primary">Submit</button>
            </div>
        </form>
    )
}